/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Heart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Heart"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M20 10.226C20 8.716 18.491 7 16.602 7c-1.476 0-2.448.841-3.028 1.58L12 10.587 10.426 8.58C9.846 7.841 8.874 7 7.398 7 5.51 7 4 8.716 4 10.226c0 1.737.819 3.268 3.34 5.467l.44.38c1.797 1.521 2.597 1.881 4.211 2.689 1.759-.872 2.552-1.22 4.67-3.069 2.52-2.199 3.339-3.73 3.339-5.467m1.996.242c-.081 2.484-1.42 4.464-4.02 6.732-2.674 2.334-3.592 2.57-5.988 3.8l-1.555-.784C9.049 19.52 8.03 18.95 6.024 17.2c-2.599-2.268-3.939-4.248-4.02-6.732L2 10.226C2 7.628 4.389 5 7.398 5l.217.004c2.218.08 3.639 1.39 4.385 2.342C12.77 6.364 14.26 5 16.602 5 19.612 5 22 7.628 22 10.226z"
      className="SVG"
    />
  </svg>
);

export const HeartIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'heart-icon'}
      icon={Heart}
      {...props}
      size={size}
    />
  );
};
